import { Link } from 'react-router-dom';
import "./SupplierCenteralHeader.css";


export { SupplierCenteralHeader };

function SupplierCenteralHeader() {

  return (
    <header className="s-c-header">
      <div className="header-body d-flex align-center justify-between">
        <div className="header-logo">
          <Link to="/supplier-centeral-home/" className="d-flex"><img src="/images/logo.png" alt="" /></Link>
        </div>
        <div className="header-menu">
          <ul className="d-flex align-center">
            <li><Link to="/supplier-centeral-home/">Home</Link></li>
            <li><a href="#">Vendor Information</a></li>
            <li><a href="#">Help Centre</a></li>
            <li><Link to="/news-room/">News Room</Link></li>
            <li>
              <a href="#">Quick Links <span className="material-symbols-outlined">keyboard_arrow_down</span></a>
              <div className="submenu">
                <ul>
                  <li><a href="#">Octa Vendor Portal</a></li>
                  <li><a href="#">Manual Deal Income(MDI)</a></li>
                  <li><a href="#">Manhattan Transport System(MATM)</a></li>
                  <li><a href="#">Other supplier system links</a></li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div className="header-right d-flex align-center">
          <div className="search-box position-relative">
            <input type="text" className="form-control" placeholder="Search Octa supplier central" />
            <button type="button" className="header-s-btn"><span className="material-symbols-outlined">search</span></button>
          </div>
          <div className="login-box">
            <button type="button" className="header-l-btn d-flex align-center"><span className="material-symbols-outlined">login</span> Login</button>
          </div>
        </div>
      </div>
    </header>
  );
}